import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .ApiTokens {
    padding-top: rem(20px);

    &__header {
      display: flex;
      justify-content: space-between;
      padding-bottom: rem(20px);
      flex-wrap: wrap;
      gap: 12px;
    }

    &__noItemsPanel {
      height: 120px !important;
      min-height: unset !important;
    }

    &__newToken {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 12px;
      background: rgba(57, 184, 65, 0.1);
      padding: 32px;
      border-radius: 12px;

      &-caption {
        font-size: 18px;
        color: #333;
      }

      &-field {
        color: rgba(0, 0, 0, 0.25);
        padding: 16px;
        background: #fff;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1;

        &-wrapper {
          display: flex;
          gap: 8px;
        }

        &-tokenCaption {
          word-break: break-all;
        }
      }

      &-copyButton {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        border-radius: 4px;
        width: 50px;

        svg {
          width: 18px;
          height: 18px;

          path {
            fill: #000;
          }
        }
      }

      &-watchIcon {
        svg {
          g {
            stroke: rgba(0, 0, 0, 0.25);
          }
        }
      }

      &-closeIcon {
        position: absolute;
        top: 24px;
        right: 24px;

        svg {
          width: 24px;
          height: 24px;

          path {
            fill: rgba(0, 0, 0, 0.25);
          }
        }
      }
    }

    &__table {
      @include respond-to(xs) {
        .ReactDataTable__wrapper {
          overflow: auto;
        }
      }
    }

    &__modal {
      position: fixed;

      .ReactModal__Content {
        overflow: visible !important;
        max-width: 738px;
        width: 100%;
      }
    }
  }
`;

const getDynamicStyles = ({ colors, border }) => {
  return css.global`
    @import 'src/common/styling/_mixins-scss/rem';

    .ApiTokens {
      &__noItemsPanel {
        border-radius: ${border.radius};
        border: 1px dashed ${colors.lightGray.hex};
        padding: rem(30px 20px);
        text-align: center;

        h3 {
          color: ${colors.gray.hex};
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
